import { FunctionComponent, useRef } from "react";
import { delay, motion, useInView } from "framer-motion";

interface TimelineItemProps {
  label: string;
  children: any;
  position: "left" | "right";
  positionNumber: number;
  last: boolean;
  icon: any;
}

const TimelineItem: FunctionComponent<TimelineItemProps> = ({
  label,
  children,
  position,
  positionNumber,
  last,
  icon,
}) => {
  const generalDelay = 0.5 * positionNumber;

  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, margin: "-100px" });

  return (
    <motion.div
      ref={ref}
      className="timeline-item"
      animate={isInView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
      initial={{ x: -100, opacity: 0 }}
      transition={{
        type: "spring",
        // delay: generalDelay,
        // delayChildren: generalDelay,
        duration: 1,
        // opacity: { duration: 2 },
      }}
    >
      <div
        className={
          position === "left" ? "timeline-left label" : "timeline-left"
        }
      >
        {position === "left" ? label : children}
      </div>
      {icon}
      {!last && (
        <motion.div
          initial={{ height: 0 }}
          animate={isInView ? { height: "calc(100% - 25px)" } : {}}
          transition={{
            height: { duration: 0.5, delay: 0.05 },
          }}
          className="timeline-line"
        />
      )}
      <div
        className={
          position === "right" ? "timeline-right label" : "timeline-right"
        }
      >
        {position === "right" ? label : children}
      </div>
    </motion.div>
  );
};

export default TimelineItem;
